export default function WhatWeDoSection() {
  const services = [
    {
      title: 'Sustainable Brand',
      subtitle: 're:day',
      description: '업사이클 패션 브랜드',
      icon: 'ri-recycle-line',
    },
    {
      title: 'Functional Workwear',
      subtitle: '고기능성 워크웨어',
      description: '산업 현장을 위한 보호 의류',
      icon: 'ri-shield-check-line',
    },
    {
      title: 'Craft Community',
      subtitle: '봉제 기술 공동체',
      description: '기술 기반 자립 모델',
      icon: 'ri-team-line',
    },
  ];

  return (
    <section className="py-28 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-5" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            우리가 하는 일
          </h2>
          <div className="w-20 h-1 bg-emerald-600 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-10 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-emerald-50 rounded-lg mb-6 group-hover:bg-emerald-100 transition-colors">
                <i className={`${service.icon} text-3xl text-emerald-600`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                {service.title}
              </h3>
              <p className="text-lg text-emerald-600 font-medium mb-3">
                {service.subtitle}
              </p>
              <p className="text-base text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}